import styled from 'styled-components';

const SpecialtiesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 48px;
`;

const SpecialtiesTitleAndOrderContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;

  h2 {
    color: var(--secondary-color);
  }
`;

const SpecialtiesList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 32px;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 700px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export {
  SpecialtiesContainer,
  SpecialtiesTitleAndOrderContainer,
  SpecialtiesList,
};
